/**
 * Authenticate Store
 * 로그인 Store
 *
 * @since 2018-01-05
 * @author kdydesign.kim
 */

// frontend 내 관련 token 강제 만료
const forceExpire = commit => {
  sessionStorage.clear()
  commit('setToken', void 0)
  commit('setIssueDate', void 0)
  commit('setRefreshToken', void 0)
  commit('setEncryptionAesKey', void 0)
  // TAMS
  commit('setCsrfToken', void 0)
  commit('initGeToken')
}

export const state = () => ({
  hakey: void 0,
  isLogout: false,
  authToken: void 0,
  authIssueDate: void 0,
  authRefreshToken: void 0,
  encryptionAesKey: void 0,
  csrfToken: void 0,
  // TAMS
  withoutLogout: false,
  alreadyRequestLogout: false,
  geToken: void 0
})

export const mutations = {
  // 토큰 설정
  setToken (state, data) {
    state.authToken = data
  },

  // TAMS
  initGeToken (state) {
    state.geToken = void 0
  },
  setGeToken (state, data) {
    if (typeof data !== 'undefined') {
      state.geToken = data.geToken
      state.authToken = data.authToken
    }
  },

  // HA Key 저장
  setHaKey (state, data) {
    state.hakey = data
  },

  // 토큰 만료 시간 설정
  setIssueDate (state, data) {
    state.authIssueDate = data
  },

  // 재발급 토큰 설정
  setRefreshToken (state, data) {
    state.authRefreshToken = data
  },

  // 토큰 정보 갱신
  getRefreshToken (state, data) {
    state.authIssueDate = data.issue_date
    state.authRefreshToken = data.refresh_token
    state.authToken = data.api_token
  },

  // AES Key 정보 저장
  setEncryptionAesKey (state, key) {
    state.encryptionAesKey = key
  },

  // TAMS
  // CSRF 토큰 정보 저장
  setCsrfToken (state, payload) {
    state.csrfToken = payload
  },
  setWithoutLogout (state, payload) {
    state.withoutLogout = payload
  },
  setAlreadyRequestLogout (state) {
    state.alreadyRequestLogout = true
  }
}

export const actions = {
  // 토큰, 만료 시간, 재발급 토큰 설정
  setToken ({commit, state}, {token, issueDate, refreshToken, secuiHelperKey, csrfToken}) {
    commit('setToken', token)
    commit('setIssueDate', issueDate)
    commit('setRefreshToken', refreshToken)
    commit('setEncryptionAesKey', secuiHelperKey)
    // TAMS
    commit('setCsrfToken', csrfToken)
  },

  // 토큰 갱신
  async getRefreshToken ({state, commit}, {refreshToken}) {
    const {code, result} = await this.$axios.$put('/api/au/refresh-token', void 0, {
      headers: {
        Authorization: refreshToken
      },
      successAlert: false,
      loading: false,
      ignoreHaPrefix: true
    })

    if (code === 'ok') {
      commit('getRefreshToken', result)

      return {
        apiToken: result.api_token,
        refreshToken: result.refresh_token,
        issueDate: result.issue_date
      }
    }
  },

  // 개발용 로그인
  async loginDev ({commit, dispatch, rootState}, {lang, username, csrfToken, password, adminOtp}) {
    try {
      const params = {
        username: username,
        password: password,
        csrf_token: csrfToken,
        force: 'True',
        ip_force: 'True'
      }
      if (_.get(adminOtp, ['length'], 0) > 0) {
        params.admin_otp = adminOtp
        params.admin_otp_type = 1
      }
      const {code, result} = await this.$axios.$post('/api/au/login', params, {
        // headers: {'X-SECUI-DEBUG': '1'},
        successAlert: false
      })

      if (code === 'ok') {
        const route = result.route,
          apiToken = result.api_token,
          issueDate = result.issue_date,
          refreshToken = result.refresh_token,
          helperKey = result.secui_helper_key,
          // haSessionKey = result.ha_session_data,
          langType = result.lang_type // KO

        // 2018.11.08 김민수 - 다국어 코드 추가
        sessionStorage.setItem('SESSION_STORAGE_SET_LANG', langType)
        sessionStorage.setItem('SESSION_STORAGE_SET_ROUTE', route)
        sessionStorage.setItem('SESSION_STORAGE_SET_TOKEN', apiToken)
        sessionStorage.setItem('SESSION_STORAGE_SET_ISSUE_DATE', issueDate)
        sessionStorage.setItem('SESSION_STORAGE_SET_REFRESH_TOKEN', refreshToken)
        sessionStorage.setItem('ENCRYPTION_AES_KEY', helperKey)

        // HA 접속 키 추가
        // sessionStorage.setItem('SESSION_STORAGE_SET_HA_SESSION_KEY', haSessionKey)

        // TAMS
        sessionStorage.setItem('SESSION_STORAGE_SET_CSRF_TOKEN', csrfToken)

        // this.$router.replace({path: '/'})
        window.location.replace('/')
      } else {
        return result.msg
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        throw new Error('Bad credentials')
      }
      throw error
    }
  },

  // TAMS - beforeunload logout 용
  async needLogout ({state}, authToken) {
    // Chrome 78버전 beforeunload xhr 동기 미지원 문제 해결
    try {
      await this.$axios.$delete('/api/au/logout', {
        successAlert: false,
        ignoreHaPrefix: true,
        headers: {
          Authorization: authToken
        }
      })
    } catch (e) {}
  },

  // 로그아웃
  async logout ({state, commit}) {
    // Chrome 78버전 beforeunload xhr 동기 미지원 문제 해결
    try {
      await this.$axios.$delete('/api/au/logout', {
        successAlert: false,
        ignoreHaPrefix: true,
        headers: {
          Authorization: state.authToken
        }
      })
    } catch (e) {}

    // 로그아웃 확인
    state.isLogout = true

    // TAMS 미필요
    // // VS 새창일 경우 강제종료
    // if (rootState.virtualSystem.systemManage.common.vsId) {
    //   window.close()
    // } else {
    //   window.location.href = '/'
    // }

    // TAMS
    // 강제 만료
    forceExpire(commit)

    const getUrlParameter = (name) => {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
      var results = regex.exec(location.search)
      return results === null ? void 0 : decodeURIComponent(results[1].replace(/\+/g, ' '))
    }

    const isNewWindow = typeof getUrlParameter('newWindow') !== 'undefined'

    // 새창일 경우 강제종료
    if (this.$axios.defaults.baseURL !== '/' || isNewWindow) {
      window.close()
    } else {
      window.location.replace('/')
    }
  },

  // 로그아웃 - axios 없이 로그아웃 (TAMS 미사용)
  async logoutWithoutAxios ({rootState}, {
    protocol = window.location.protocol,
    host = window.location.hostname,
    port = window.location.port
  }) {
    // VS 새창일 경우 강제종료
    if (rootState.virtualSystem.systemManage.common.vsId) {
      window.close()
    } else {
      window.location = `${protocol}//${host}:${port}/`
    }
  },

  // Window Unload 시 로그아웃
  unloadLogout ({state, commit}) {
    // 새창 윈도우 모두 종료
    this.commit('common/common/initNewWindows')
    // 강제 만료
    forceExpire(commit)

    // 로그아웃 강제되지 않아야 할 기능 (시스템 재시작/중지)
    if (!state.withoutLogout || !state.isLogout) {
      // Chrome 78 이후 버전 beforeunload 시 async 안됨. 85 버전 이후 지원안될 예정
      $.ajax({
        type: 'delete',
        url: `${this.$axios.defaults.baseURL}api/au/logout`,
        headers: {
          Authorization: state.authToken
        },
        async: false
      })
    }

    // TAMS, 화면 세션 만료 이후 서버 요청 방어
    this.commit('common/common/clearAgentTimeTimer')
  },

  // TAMS 는 현재 안 씀
  // 개발용 초기설치 로그인
  async loginInitDev ({commit, dispatch, rootState}, {lang, username, password}) {
    try {
      const {code, result} = await this.$axios.$post('/api/au/login', {
        login_id: username,
        login_pw: password,
        type: 'local',
        force: 'True'
      }, {successAlert: false})

      if (code === 'ok') {
        const route = result.route,
          apiToken = result.api_token,
          issueDate = result.issue_date,
          refreshToken = result.refresh_token,
          helperKey = result.secui_helper_key,
          haSessionKey = result.ha_session_data

        // 2018.11.08 김민수 - 다국어 코드 추가
        sessionStorage.setItem('SESSION_STORAGE_SET_LANG', lang)
        sessionStorage.setItem('SESSION_STORAGE_SET_ROUTE', route)
        sessionStorage.setItem('SESSION_STORAGE_SET_TOKEN', apiToken)
        sessionStorage.setItem('SESSION_STORAGE_SET_ISSUE_DATE', issueDate)
        sessionStorage.setItem('SESSION_STORAGE_SET_REFRESH_TOKEN', refreshToken)
        sessionStorage.setItem('ENCRYPTION_AES_KEY', helperKey)

        // HA 접속 키 추가
        sessionStorage.setItem('SESSION_STORAGE_SET_HA_SESSION_KEY', haSessionKey)

        this.$router.replace({path: '/install/initAlIInstallation'})
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        throw new Error('Bad credentials')
      }
      throw error
    }
  }

}

export const getters = {
  // 토큰 여부
  isAuthToken (state) {
    return !!state.authToken
  },
  isExistGeToken (state) {
    return !!state.geToken
  }
}

export const strict = false
